import {
  PreviousAnswersDto,
  ProductMaturityConfig,
  QuestionField,
  WelcomeComponentOptions,
} from './schema.ts';
import { FieldOverrides, PreviewOptions } from '../extensions.ts';

export function trimSlash(base: string) {
  return base.replace(/\/$/, '');
}

const toBoolean = (v: string) => v?.endsWith('yes') ?? false;

function parseValues(field: QuestionField, overrides: FieldOverrides) {
  const fieldType = overrides[field.shortQuestionName]?.type || field.dataType;
  return fieldType === 'boolean'
    ? toBoolean(field.shortAnswerTypeName)
    : field.shortAnswerTypeName;
}

export function parseResponse(
  answers: PreviousAnswersDto,
  fieldOverrides: FieldOverrides = {},
): Record<string, any> {
  const entries = answers.fields.map(field => {
    const key = field.shortQuestionName;
    const value = parseValues(field, fieldOverrides);

    return [key, value];
  });

  return Object.fromEntries(entries);
}

type Deps = {
  config: ProductMaturityConfig;
  options: Pick<WelcomeComponentOptions, 'kind' | 'query'>;
  previewOpts?: PreviewOptions;
};

export async function fetchPreviousAnswer(product: string, deps: Deps) {
  const { config, options, previewOpts } = deps;
  const { baseUrl, apiKey, endpointGuid } = config;
  const segment = options.kind === 'label' ? 'labels' : 'labelTypes';
  const headers = new Headers();
  headers.set('Authorization', apiKey);
  try {
    const endpoint = `${trimSlash(
      baseUrl,
    )}/${endpointGuid}/targets/${product}/${segment}/${
      options.query
    }/recentAnswers`;
    const result = await fetch(endpoint, {
      headers,
    });
    if (result.ok) {
      const rawResult: PreviousAnswersDto = await result.json();
      return parseResponse(rawResult, previewOpts?.fieldOverrides);
    }
    return {};
  } catch (error) {
    return {};
  }
}
